import React, { FC, useState } from 'react';

import { PlusOutlined } from '@ant-design/icons';
import { Button, Layout, Row, Space, Table } from 'antd';
import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { HeaderTitle } from '@components/HeaderTitle';
import { CreateProcessModal } from '@pages/Processes/components/ControlProcess/components/CreateProcessModal';

import { Container } from './styles';

export const EmptyList: FC = () => {
  const [createModalOpen, setCreateModalOpen] = useState(false);

  const processesT = useTranslation(NSKeys.processes);

  return (
    <>
      <Layout.Header>
        <Row justify="space-between" align="middle">
          <HeaderTitle title={processesT.t('title')} />
          <Space size="middle">
            <Button type="primary" icon={<PlusOutlined />} onClick={() => setCreateModalOpen(true)} size="middle">
              {processesT.t('add')}
            </Button>
          </Space>
        </Row>
      </Layout.Header>

      <CreateProcessModal open={createModalOpen} onClose={() => setCreateModalOpen(false)} />
      <Container style={{ position: 'relative' }}>
        <Table />
      </Container>
    </>
  );
};
